import { IAnalysisResponse } from '../../../utils/apollo/responseTypes';
import { assertCondition, GraphQLLocalDate } from '../../../utils/types';
import {
  globalFormat,
  INumberFormatOptionProps,
} from '../../../utils/formatting';
import { Locale } from '../../../utils/apollo/graphqlSchema';
import { IFormatProgressBarValueProps } from './types';
import moment from 'moment';
import { INTERNAL_DATE_FORMAT } from '../../../config/constants';

export const calculateTotal = (mtuReport: IAnalysisResponse): number => {
  assertCondition(
    mtuReport.__typename === 'Expression' && mtuReport?.data,
    'Invalid MTU Report Type!',
  );

  const { columns } = mtuReport?.data;
  if (!columns || !columns.length) {
    return 0;
  }

  // get the first column, the expectations are that there will be always only one
  const first = columns[0];

  return first.values.reduce<number>((acc, v): number => acc + (v ?? 0), 0);
};

/**
 * Returns value in short compact format 50 000 000 -> 50M, for locale en-US
 * @param value
 * @param locale
 */

export const formatNumberCompactShort = (value: number, locale: Locale) => {
  return globalFormat.formatNumber(value, {
    locale,
    notation: 'compact',
    style: 'decimal',
    maximumFractionDigits: 2,
  });
};

export const formatProgressBarValue = ({
  value,
  max,
  isUnlimited,
  locale,
}: IFormatProgressBarValueProps) => {
  const formatOptions: INumberFormatOptionProps = {
    locale,
    notation: 'compact',
    maximumFractionDigits: 2,
    style: 'decimal',
  };

  return isUnlimited
    ? 'Unlimited'
    : `${globalFormat.formatNumber(value, formatOptions)} /  ${globalFormat.formatNumber(max, formatOptions)}`;
};

export const calculatePlanMonths = (
  from: GraphQLLocalDate,
  to: GraphQLLocalDate,
): number => {
  return moment(to, INTERNAL_DATE_FORMAT, true).diff(
    moment(from, INTERNAL_DATE_FORMAT, true),
    'months',
    true,
  );
};

export const formatPeriod = (
  from: GraphQLLocalDate,
  to: GraphQLLocalDate,
): string => {
  const { dateFormat } = globalFormat.getGlobalFormat();

  const toString = globalFormat.formatDate(to, { dateFormat });

  const fromString = globalFormat.formatDate(from, { dateFormat });

  return `${fromString} - ${toString}`;
};
